import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EstimateVersion } from "../../models/estimate.model";
import { showSnackbar } from "projects/common/src/lib/components/snackbar/snackbar.component";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { EstimatesService } from "../../services/estimates.service";

@Component({
  selector: 'app-estimate-editable',
  templateUrl: './estimate-editable.component.html',
  styleUrls: ['./estimate-editable.component.scss']
})
export class EstimateEditableComponent {

  @Input() estimate: any;
  @Input() currentEstimateVersion!: EstimateVersion;
  @Input() scrollPosition: any;
  @Input() readonly = false;

  @Output() editableInFocus = new EventEmitter<boolean>();

  noteFocused: boolean = false;
  currentNote: string = '';

  constructor(
    private snackBar: MatSnackBar,
    private estimatesService: EstimatesService,
  ) { }

  async noteFocusout(currentEstimateVersionId: number, note: string | null) {
    this.noteFocused = false;
    if (note !== this.currentNote) {
      try {
        await this.estimatesService.updateEstimateNote(
          currentEstimateVersionId,
          note ?? ''
        );
        showSnackbar(this.snackBar, {
          message: "Note updated",
          duration: 2000
        });
      } catch (e) {
        alert('Something went wrong')
      }
    }
  }
}
